import Vue from 'vue'
import Vuex from 'vuex'

import APIService from '@/apiservices/APIService.js'

//import * as apidata from '@/store/modules/apidata'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {},
  state: {
    user: null,
    accesstoken: '',
    refreshtoken: '',
    goto_url: '',
    administrators: [],
    articlesListOptions: {},
    version: {},
    homeblogYearTabIndex: 0,
    journeyYearTabIndex: 0
  },
  mutations: {
    SET_USER_DATA(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    LOGOUT_USER() {
      localStorage.removeItem('user')
      localStorage.removeItem('accesstoken')
      localStorage.removeItem('refreshtoken')
      location.reload()
    },
    SET_ACCESS_TOKEN(state, accessToken) {
      console.log('SET_ACCESS_TOKEN:', accessToken)
      state.accesstoken = accessToken
      localStorage.setItem('accesstoken', accessToken)
      APIService.setAuthorizationHeader(accessToken)
    },
    SET_REFRESH_TOKEN(state, refreshToken) {
      state.refreshtoken = refreshToken
      localStorage.setItem('refreshtoken', refreshToken)
    },
    SET_GOTO_URL(state, url) {
      state.goto_url = url
      localStorage.setItem('goto_url', url)
    },
    SET_ADMINISTRATORS(state, administrators) {
      state.administrators = administrators
    },

    SET_ARTICLES_LIST_OPTIONS(state, articlesListOptions) {
      state.articlesListOptions = articlesListOptions
      localStorage.setItem(
        'articlesListOptions',
        JSON.stringify(articlesListOptions)
      )
    },

    SET_VERSION(state, version) {
      state.version = version
    },

    SET_HOMEBLOG_YEAR_TAB_INDEX(state, homeblogYearTabIndex) {
      state.homeblogYearTabIndex = homeblogYearTabIndex
    },

    SET_JOURNEY_YEAR_TAB_INDEX(state, journeyYearTabIndex) {
      state.journeyYearTabIndex = journeyYearTabIndex
    }
  },
  actions: {
    login({ commit }, credentials) {
      return APIService.obtainTokensByMobileCode(
        credentials.mobile,
        credentials.code
      ).then(({ data }) => {
        // Разбираем токен на части и вытаскивваем из него смысловую часть
        var jsonPayload = JSON.parse(getPayload(data.access))
        console.log('Token Payload:', jsonPayload)
        // Создаем объект user с данными, которые могут понадобитьсяя для отображенния или логики поведения залогиненнного пользователя
        var userData = {}
        userData.mobile = jsonPayload.mobile
        userData.email = jsonPayload.email
        userData.is_admin = jsonPayload.is_admin
        userData.name = jsonPayload.name
        userData.person_id = jsonPayload.person_id
        userData.avatar_filename = jsonPayload.avatar_filename
        userData.adminMode = false
        commit('SET_USER_DATA', userData)
        commit('SET_ACCESS_TOKEN', data.access)
        commit('SET_REFRESH_TOKEN', data.refresh)
      })
    },

    // используется при замене просроченного access token пир процедуре рефреша
    setNewAccessToken({ commit }, accesstoken) {
      commit('SET_ACCESS_TOKEN', accesstoken)
    },

    logout({ commit }) {
      console.log('LOGOUT')
      commit('LOGOUT_USER')
    },

    setUserAdminMode({ commit, state }, adminMode) {
      var userData = state.user
      userData.adminMode = adminMode
      commit('SET_USER_DATA', userData)
    },

    rememberURLBeforeLogin({ commit }, url) {
      commit('SET_GOTO_URL', url)
    },

    fetchAdministrators({ commit }) {
      APIService.getAdministrators()
        .then(response => {
          commit('SET_ADMINISTRATORS', response.data)
        })
        .catch(error => {
          console.log('There was an error in fetching administrators:', error)
        })
    },

    setArticlesListOptions({ commit }, articlesListOptions) {
      commit('SET_ARTICLES_LIST_OPTIONS', articlesListOptions)
    },

    fetchVersion({ commit }) {
      APIService.getVersion()
        .then(response => {
          commit('SET_VERSION', response.data.results[0])
        })
        .catch(error => {
          console.log('There was an error in fetching version:', error)
        })
    },

    setHomeblogYearTabIndex({ commit }, homeblogYearTabIndex) {
      commit('SET_HOMEBLOG_YEAR_TAB_INDEX', homeblogYearTabIndex)
    },

    setJourneyYearTabIndex({ commit }, journeyYearTabIndex) {
      commit('SET_JOURNEY_YEAR_TAB_INDEX', journeyYearTabIndex)
    }
  },

  getters: {
    loggedIn(state) {
      return !!state.user
    },
    loggedUserIsAdmin(state, getters) {
      if (getters.loggedIn) {
        return state.user.is_admin
      } else {
        return false
      }
    },
    loggedUserPersonName(state, getters) {
      if (getters.loggedIn) {
        return state.user.name
      } else {
        return ''
      }
    },
    loggedUserPersonId(state, getters) {
      if (getters.loggedIn) {
        return state.user.person_id
      } else {
        return null
      }
    },
    loggedUserAvatarFilename(state, getters) {
      if (getters.loggedIn) {
        return state.user.avatar_filename
      } else {
        return null
      }
    },
    adminMode(state, getters) {
      if (
        getters.loggedIn &&
        getters.loggedUserIsAdmin &&
        state.user.adminMode
      ) {
        return true
      } else {
        return false
      }
    },
    getRefreshToken(state) {
      return state.refreshtoken
    },
    getURLtogoAfterLogin(state) {
      return state.goto_url
    },
    getAuthorsList(state) {
      // Создаем список возможных авторов артиклов
      // Список вида [{text: user.person.name, value: user.person.id}]
      return state.administrators.map(x => {
        return { text: x.person.name, value: x.person.id }
      })
    },
    getArticlesListOptions(state) {
      console.log('GET ARTICLE LIST:', state.articlesListOptions)
      return state.articlesListOptions
    },
    getVersion(state) {
      return state.version
    },
    getHomeblogYearTabIndex(state) {
      return state.homeblogYearTabIndex
    },
    getJourneyYearTabIndex(state) {
      return state.journeyYearTabIndex
    }
  }
})

function getPayload(token) {
  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )
  return jsonPayload
}
